import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { GridLoader } from 'react-spinners';

interface CommonGridLoaderProps {
  text?: string;
  size?: number;
  color?: string;
  fullWidth?: boolean;
  minHeight?: number;
}

const CommonGridLoader: React.FC<CommonGridLoaderProps> = ({
  text = 'Loading...',
  size = 10,
  color = '#2F7E8E',
  fullWidth = true,
  minHeight = 140,
}) => {
  return (
    <Box
      sx={{
        width: fullWidth ? '100%' : 'auto',
        minHeight,
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Stack spacing={1.5} alignItems="center">
        <GridLoader color={color} size={size} margin={3} />
        <Typography variant="body2" sx={{ color }}>
          {text}
        </Typography>
      </Stack>
    </Box>
  );
};

export default CommonGridLoader;